var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"analytics-photo-modal",on:{"modal-close":_vm.handleClose}},[_c('ImageAsset',{staticClass:"rounded my-2 h-screen image-bg-cover-no-repeat",attrs:{"photo":_vm.photo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }